(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/redux/slices/containers/reducer.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/redux/slices/containers/reducer.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const containerStates = svs.numbergames.fractiongames.constants.containerStates;
const _svs$numbergames$frac = svs.numbergames.fractiongames.redux.slices.containers.ACTION_TYPES,
  CONTAINER_ADDED = _svs$numbergames$frac.CONTAINER_ADDED,
  CONTAINER_CLOSED = _svs$numbergames$frac.CONTAINER_CLOSED,
  GAME_FETCHED = _svs$numbergames$frac.GAME_FETCHED,
  GAME_GENERATED = _svs$numbergames$frac.GAME_GENERATED,
  GAME_SHARE_SOLD = _svs$numbergames$frac.GAME_SHARE_SOLD,
  GAME_SOLD_OUT = _svs$numbergames$frac.GAME_SOLD_OUT,
  GAME_BUYIN_CLOSED = _svs$numbergames$frac.GAME_BUYIN_CLOSED,
  CONTAINER_REMOVED = _svs$numbergames$frac.CONTAINER_REMOVED;
const _ref = svs.numbergames.fractiongames.data || {},
  containers = _ref.containers;
const mapContainer = svs.numbergames.fractiongames.api_calls.mapContainer;
const initialState = {
  containers: containers.map(mapContainer).reduce((acc, container) => Object.assign(acc, {
    [container.containerId]: container
  }), {})
};
const reducer = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case CONTAINER_ADDED:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          containers: _objectSpread(_objectSpread({}, state.containers), {}, {
            [action.containerId]: {
              containerId: action.containerId,
              activatedDrawId: action.activatedDrawId,
              soldShares: action.soldShares,
              productNumeric: action.productNumeric
            }
          })
        });
      }
    case GAME_FETCHED:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          containers: _objectSpread(_objectSpread({}, state.containers), {}, {
            [action.containerId]: _objectSpread(_objectSpread({}, state.containers[action.containerId]), action.container)
          })
        });
      }
    case GAME_GENERATED:
      {
        const container = state.containers[action.containerId];
        const containerState = container.buyinCloseTime ? containerStates.CONTAINER_OPEN : container.containerState;
        return _objectSpread(_objectSpread({}, state), {}, {
          containers: _objectSpread(_objectSpread({}, state.containers), {}, {
            [action.containerId]: _objectSpread(_objectSpread({}, container), {}, {
              activatedDrawId: action.activatedDrawId,
              soldShares: action.soldShares,
              containerState
            })
          })
        });
      }
    case GAME_SHARE_SOLD:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          containers: _objectSpread(_objectSpread({}, state.containers), {}, {
            [action.containerId]: _objectSpread(_objectSpread({}, state.containers[action.containerId]), {}, {
              soldShares: action.soldShares
            })
          })
        });
      }
    case GAME_SOLD_OUT:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          containers: _objectSpread(_objectSpread({}, state.containers), {}, {
            [action.containerId]: _objectSpread(_objectSpread({}, state.containers[action.containerId]), {}, {
              activatedDrawId: 0,
              containerState: containerStates.GAME_SOLD_OUT
            })
          })
        });
      }
    case GAME_BUYIN_CLOSED:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          containers: _objectSpread(_objectSpread({}, state.containers), {}, {
            [action.containerId]: _objectSpread(_objectSpread({}, state.containers[action.containerId]), {}, {
              containerState: containerStates.CONTAINER_CLOSED
            })
          })
        });
      }
    case CONTAINER_CLOSED:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          containers: _objectSpread(_objectSpread({}, state.containers), {}, {
            [action.containerId]: _objectSpread(_objectSpread({}, state.containers[action.containerId]), {}, {
              activatedDrawId: 0,
              soldShares: 0,
              buyinCloseTime: null,
              containerState: containerStates.CONTAINER_CLOSED
            })
          })
        });
      }
    case CONTAINER_REMOVED:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          containers: Object.values(state.containers).reduce((containers, container) => {
            if (container.containerId !== action.containerId) {
              containers[container.containerId] = container;
            }
            return containers;
          }, {})
        });
      }
    default:
      return state;
  }
};
Object.assign(svs.numbergames.fractiongames.redux.slices.containers, {
  reducer
});

 })(window);